module.exports = __webpack_public_path__ + "img/flag_pt.c48bd53.svg";